import React from 'react';
import { withUser } from '../../../../contexts/User/withUser';
import { IUserProviderProps } from '../../../../contexts/User/UserProvider';
import { ICashierPaymentsApi } from '@wix/cashier-payments-widget';
import { withLocation } from '../../../../contexts/Location/withLocation';
import { ILocationProviderProps } from '../../../../contexts/Location/LocationProvider';
import { Pages } from '../../../../contexts/Location/LocationContext';
import { withChallengeData } from '../../../../contexts/ChallengeDataProvider/withChallengeData';
import { applyProviders } from '../../../../services/applyProviders';
import {
  useExperiments,
  withExperiments,
} from '../../../../contexts/Experiments/ExperimentsContext';
import { IExperimentsContext } from '../../../../contexts/Experiments/interfaces';
import { PaymentWidget } from './PaymentWidget';
import { GeneralDataContext } from '../../../../contexts/GeneralDataProvider/GeneralDataContext';
import { getOrderId } from '../../../../selectors/participants';
import { useEnvironment } from 'yoshi-flow-editor-runtime';
import { BIProviderPropsMap } from '../../../../contexts/BI/interfaces';
import { withBI } from '../../../../contexts/BI/withBI';
import { Challenges } from '../../../../editor/types/Experiments';
import { IChallengeDataProps } from '../../../../contexts/ChallengeDataProvider/helpers';

export interface IContainerProps {
  onApiReady(api: ICashierPaymentsApi): void;
  onWidgetLoaded(): void;
}

let requestInProgress = false;

type IPaymentContainerProps = IUserProviderProps &
  BIProviderPropsMap &
  IContainerProps &
  IExperimentsContext &
  ILocationProviderProps &
  IChallengeDataProps;

export const PaymentWidgetContainer: React.FC<IContainerProps> = applyProviders(
  (props: IPaymentContainerProps) => {
    // tslint:disable-next-line:react-hooks-nesting
    const experiments = useExperiments();
    // tslint:disable-next-line: react-hooks-nesting
    const { appDefinitionId, language } = useEnvironment();
    // tslint:disable-next-line: react-hooks-nesting
    const { instanceId, instance, host } = React.useContext(GeneralDataContext);
    const challenge = props.challengeData?.challenge || {};
    const slug = experiments.enabled(Challenges.enableSlugsInUrl)
      ? challenge?.settings?.seo?.slug
      : challenge?.id;

    if (!slug) {
      return null;
    }

    const currency =
      challenge?.settings?.pricing?.singlePayment?.price?.currency;

    if (!props.user || !getOrderId(props.participant)) {
      props.goToPage({
        pageId: Pages.Details,
        challengeId: slug,
      });
      return null;
    }

    if (!props.participant && !requestInProgress) {
      requestInProgress = true;
    }

    return (
      <PaymentWidget
        ownerId={props.ownerId}
        appId={appDefinitionId}
        userId={props.user.id}
        instanceId={instanceId}
        instance={instance}
        host={host}
        locale={language}
        orderId={getOrderId(props.participant)}
        onApiReady={props.onApiReady}
        onWidgetLoaded={props.onWidgetLoaded}
        currency={currency}
        paymentComplete={() => {
          // tslint:disable-next-line: no-floating-promises
          props.updateParticipant(); // update because state is changed after payment
          props.goToPage({
            pageId: Pages.ThankYou,
            challengeId: slug,
          });
        }}
      />
    );
  },
  [withChallengeData, withLocation, withUser, withExperiments, withBI],
);

PaymentWidgetContainer.displayName = 'PaymentWidgetContainer';
